import { gql } from '@apollo/client';

export const RESEND_APPLICANT_PASSWORD_INITIALIZATION = gql`
  mutation resendApplicantPasswordInitialization($trackId: IdentifierType!, $applicantId: IdentifierType!) {
    resendApplicantPasswordInitialization(trackId: $trackId, applicantId: $applicantId) {
      outcomeMessage
    }
  }
`;
